import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ui-page" }
const _hoisted_2 = { class: "titlebar" }
const _hoisted_3 = { class: "titlebar-content" }
const _hoisted_4 = { class: "titlebar-title --mobile" }
const _hoisted_5 = { class: "titlebar-text" }
const _hoisted_6 = { class: "titlebar-actions" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "titlebar-actions-secondary" }, null, -1)
const _hoisted_8 = { class: "titlebar-actions-primary" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Salvar")
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "ui-card" }
const _hoisted_12 = { class: "ui-card-body" }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_16 = { class: "ant-row ui-p-l-r" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_19 = { class: "ant-row" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_21 = { class: "ant-row" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_editor_html = _resolveComponent("editor-html")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_itens_lista_simples = _resolveComponent("itens-lista-simples")!
  const _component_itens_lista_sub_itens = _resolveComponent("itens-lista-sub-itens")!
  const _component_itens_cores = _resolveComponent("itens-cores")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_comunicacao_api = _resolveComponent("comunicacao-api")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.appBase.titulo), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "ui-button -primary",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.salvar()))
          }, _hoisted_10)
        ])
      ])
    ]),
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.appBase.carregando,
          paragraph: { rows: 10 }
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_a_form_item, { label: "Nome" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "255",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.caracteristica.nome) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.caracteristica.nome]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_a_form_item, { label: "Status" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_group, {
                          value: _ctx.state.caracteristica.status,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.caracteristica.status) = $event)),
                          "button-style": "solid"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: false }, {
                              default: _withCtx(() => [
                                _createTextVNode("Inativa")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: true }, {
                              default: _withCtx(() => [
                                _createTextVNode("Ativa")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_a_checkbox, {
                      class: "ui-full",
                      checked: _ctx.state.caracteristica.filtro,
                      "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.caracteristica.filtro) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Apresentar como Filtro nas pesquisas")
                      ]),
                      _: 1
                    }, 8, ["checked"])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_a_checkbox, {
                      class: "ui-full",
                      checked: _ctx.state.caracteristica.variacao,
                      "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.caracteristica.variacao) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Utilizar na variação dos produtos")
                      ]),
                      _: 1
                    }, 8, ["checked"])
                  ])
                ]),
                _createVNode(_component_a_divider, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Descrição")
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_editor_html, {
                      value: _ctx.state.caracteristica.descricao,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.caracteristica.descricao) = $event))
                    }, null, 8, ["value"])
                  ])
                ]),
                _createVNode(_component_a_divider, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Tipo")
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_a_radio_group, {
                      value: _ctx.state.caracteristica.tipo,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.caracteristica.tipo) = $event)),
                      name: "radioGroup",
                      class: "ui-radio"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio, { value: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode("Texto")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_radio, { value: 2 }, {
                          default: _withCtx(() => [
                            _createTextVNode("Número")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_radio, { value: 3 }, {
                          default: _withCtx(() => [
                            _createTextVNode("Valor Decimal")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_radio, { value: 4 }, {
                          default: _withCtx(() => [
                            _createTextVNode("Lista Simples")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_radio, { value: 5 }, {
                          default: _withCtx(() => [
                            _createTextVNode("Lista SubItens")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_radio, { value: 6 }, {
                          default: _withCtx(() => [
                            _createTextVNode("Cor")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ])
                ]),
                (_ctx.state.caracteristica.tipo === _ctx.ETipoCaracteristica.ListaSimples)
                  ? (_openBlock(), _createBlock(_component_itens_lista_simples, {
                      key: 0,
                      codigoCaracteristica: _ctx.state.caracteristica.codigo,
                      itensListaSimples: _ctx.state.caracteristica.itens,
                      "onUpdate:itensListaSimples": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.caracteristica.itens) = $event))
                    }, null, 8, ["codigoCaracteristica", "itensListaSimples"]))
                  : _createCommentVNode("", true),
                (_ctx.state.caracteristica.tipo === _ctx.ETipoCaracteristica.ListaSubItens)
                  ? (_openBlock(), _createBlock(_component_itens_lista_sub_itens, {
                      key: 1,
                      codigoCaracteristica: _ctx.state.caracteristica.codigo,
                      itensListaSubItens: _ctx.state.caracteristica.itens,
                      "onUpdate:itensListaSubItens": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.caracteristica.itens) = $event))
                    }, null, 8, ["codigoCaracteristica", "itensListaSubItens"]))
                  : _createCommentVNode("", true),
                (_ctx.state.caracteristica.tipo === _ctx.ETipoCaracteristica.Cores)
                  ? (_openBlock(), _createBlock(_component_itens_cores, {
                      key: 2,
                      codigoCaracteristica: _ctx.state.caracteristica.codigo,
                      itensCores: _ctx.state.caracteristica.itens,
                      "onUpdate:itensCores": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.caracteristica.itens) = $event))
                    }, null, 8, ["codigoCaracteristica", "itensCores"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }),
    _createVNode(_component_comunicacao_api, {
      visivel: _ctx.appBase.exibirComunicaoApi,
      "onUpdate:visivel": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.appBase.exibirComunicaoApi) = $event)),
      apresentarBarraProgresso: _ctx.appBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.appBase.fraseBarraProgresso,
      resposta: _ctx.appBase.resposta
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "resposta"])
  ]))
}